const PENDING_KEY = 'afterLoginPopupPending';

/**
 * called when the manager logs in, so the popup on the all buildings page is shown once per login.
 * without this flag the popup shows on every visit to that page, also when already logged in
 * */
export function markAfterLoginPopupPending() {
    window.localStorage.setItem(PENDING_KEY, 'true');
}

/**
 * true only on the first check after a login. the flag is consumed, so later visits to the page
 * do not show the popup again until the next login
 * @return {boolean}
 * */
export function consumeAfterLoginPopupPending() {
    const pending = window.localStorage.getItem(PENDING_KEY) === 'true';
    if (pending) {
        window.localStorage.removeItem(PENDING_KEY);
    }
    return pending;
}
